var map = {
	"./CoItracker.png": "f9e3",
	"./Drone_vector_Sticker.png": "c784",
	"./Ello-2.png": "d654",
	"./Ello-3.png": "e948",
	"./Ello.png": "602a",
	"./Generali.png": "7fd7",
	"./Loop.png": "d8a1",
	"./Mezink.png": "238c",
	"./Stryker.png": "375b",
	"./Synth.png": "976d",
	"./aakash_logo.png": "762a",
	"./close_icon.png": "4ed6",
	"./cur_rect.png": "11df",
	"./himachal.png": "4487",
	"./image334.png": "fe24",
	"./image335.png": "ad13",
	"./image336.png": "bb7d",
	"./image337.png": "3a2f",
	"./image338.png": "c46b",
	"./image339.png": "0686",
	"./kerala.png": "afa2",
	"./logo_1.png": "014c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";